import { AppName } from 'root-constants'
import { TAppName, TValueOf } from 'root-types'

export const STARS_COUNT = 5

export const HEADER_POSITIONS = {
  TOP: 'top',
  BOTTOM: 'bottom',
} as const

export const RECOMMENDATION_KEY = {
  [AppName.blessedPath]: 'commonComponents.reviewsRecommendationBlessedPath',
  [AppName.ayahPath]: 'commonComponents.reviewsRecommendationAyahPath',
  [AppName.karmaPath]: 'commonComponents.reviewsRecommendationKarmaPath',
} as const satisfies Record<TAppName, string>

export type THeaderPositions = TValueOf<typeof HEADER_POSITIONS>
